import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import { SnackbarContextProvider } from "./contexts/SnackbarContext";
import "./index.css";
import AsciiImagePage from "./pages/AsciiImagePage";
import AsciiVideoPage from "./pages/AsciiVideoPage";
import HiddenSpacePage from "./pages/HiddenSpacePage";
import HiddenSpaceGamePage from "./pages/HiddenSpaceGamePage";
import HolidayCardPage from "./pages/HolidayCardPage";
import HomePage from "./pages/HomePage";
import { YearBingoPage } from "./pages/YearBingoPage";
import reportWebVitals from "./reportWebVitals";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <HomePage />,
      },
    ],
  },
  {
    path: "/holidaycard",
    element: <App />,
    children: [
      {
        path: "/holidaycard/:year",
        element: <HolidayCardPage />,
      },
    ],
  },
  {
    path: "/bingo",
    element: <App />,
    children: [
      {
        path: "/bingo/:year/:user",
        element: <YearBingoPage />,
      },
    ],
  },
  {
    path: "/asciiart",
    element: <App />,
    children: [
      { path: "/asciiart/image", element: <AsciiImagePage /> },
      { path: "/asciiart/video", element: <AsciiVideoPage /> },
    ],
  },
  {
    path: "/hiddenspace",
    element: <App />,
    children: [
      {
        path: "/hiddenspace",
        element: <HiddenSpacePage />,
      },
          {
            path: "/hiddenspace/game/:gameID",
            element: <HiddenSpaceGamePage />,
          },
    ],
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={new QueryClient()}>
      <SnackbarContextProvider>
        <RouterProvider router={router} />
      </SnackbarContextProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
